module.exports = __webpack_public_path__ + "media/images/plan-check-6f6e26fabc529cc3d6d0841b6bce88b1.svg";